export const PERSONAL_API_KEY_DETAILS_URL_PARAM = "apiKeyId";
